/**
 * Renders a thumbnailimage that can be edited with a text field layover
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import EditOverlay from './EditOverlay';

class EditableThumbnail extends Component {
    static propTypes = {
        hidden: PropTypes.bool,
        imgSrc: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        label: PropTypes.string,
        defaultValue: PropTypes.string,
        editLabel: PropTypes.string,
        onSubmit: PropTypes.func,
        onClick: PropTypes.func,
        editClicked: PropTypes.func,
        playIcon: PropTypes.node,
        clickable: PropTypes.bool.isRequired,
        disabled: PropTypes.bool.isRequired,
        parentEditMode: PropTypes.func,
    };

    static defaultProps = {
        disabled: false,
    };

    state = {
        editMode: false,
    };

    onEditClicked(e) {
        e.preventDefault();
        if (this.props.editClicked) {
            this.props.editClicked();
        }
        this._showEditor();
    }

    onCancel() {
        this._hideEditor();
    }

    onClick(e) {
        // Not allowed to trigger while in edit mode

        if (!this.state.editMode && this.props.onClick) {
            this.props.onClick(e);
        }
    }

    onSubmit(description) {
        this.props.onSubmit(description);
        this._hideEditor();
    }

    _showEditor() {
        this.setState({ editMode: true });
        if (this.props.parentEditMode) {
            this.props.parentEditMode(true);
        }
    }

    _hideEditor() {
        this.setState({ editMode: false });
        if (this.props.parentEditMode) {
            this.props.parentEditMode(false);
        }
    }

    renderEditComponent() {
        const editClasses = cn({
            'u-display-none': this.state.editMode,
        });

        if (!this.props.disabled) {
            return (
                <React.Fragment>
                    <span className={editClasses}>
                        <button
                            className="button button--flat"
                            onClick={this.onEditClicked.bind(this)}
                            type="button"
                        >
                            {this.props.editLabel}
                        </button>
                    </span>
                    {this.props.children}
                </React.Fragment>
            );
        }
    }

    render() {
        const overlayClasses = cn({
            'u-display-none': this.props.hidden,
        });

        return (
            <section>
                <div className={overlayClasses}>
                    <EditOverlay
                        clickable={this.props.clickable}
                        defaultValue={this.props.defaultValue}
                        editMode={this.state.editMode}
                        imgSrc={this.props.imgSrc}
                        label={this.props.label}
                        onCancel={this.onCancel.bind(this)}
                        onClick={this.onClick.bind(this)}
                        onSubmit={this.onSubmit.bind(this)}
                        placeholder={this.props.placeholder}
                        playIcon={this.props.playIcon}
                    />
                </div>
                {this.renderEditComponent()}
            </section>
        );
    }
}

export default EditableThumbnail;
